// Anzen
import s3Heading from './anzen/utils/s3Heading.json';
import snowflakeHeading from './anzen/utils/snowflakeHeading.json';
import dataExfiltrationMapES from './anzen/databaseExfiltrationES/dataExfiltrationMapES.json';
import eventTimelineES from './anzen/databaseExfiltrationES/eventTimelineES.json';
import exfiltrationDetailsPanelsES from './anzen/databaseExfiltrationES/exfiltrationDetailsPanelsES.json';
import dataExfiltrationMapLS from './anzen/databaseExfiltrationLS/dataExfiltrationMapLS.json';
import eventTimelineLS from './anzen/databaseExfiltrationLS/eventTimelineLS.json';
import exfiltrationDetailsPanelsLS from './anzen/databaseExfiltrationLS/exfiltrationDetailsPanelsLS.json';
import alertOverview from './anzen/alertOverview.json';
import healthIcon from './anzen/utils/healthIcon.json';
import descriptionCell from './anzen/utils/descriptionCell.json';
import tableOverview from './anzen/tables/tableOverview.json';
import columnsTable from './anzen/tables/columnsTable.json';
import usersTable from './anzen/tables/usersTable.json';
import activityChartsByTable from './anzen/tables/activityChartsByTable.json';
import anzenCellHealthIcon from './anzen/anzenCellHealthIcon.json';
import overlayGraph from './anzen/parallelCoordinates/overlayGraph.json';
import activityGraphColumn from './anzen/parallelCoordinates/activityGraphColumn.json';
import activityGraphTable from './anzen/parallelCoordinates/activityGraphTable.json';
import configurationGraphColumn from './anzen/parallelCoordinates/configurationGraphColumn.json';
import tablePIIColumns from './anzen/tablePIIColumns.json';
import lineGraphColumns from './anzen/lineGraph/lineGraphColumn.json';
import databaseProviderOverview from './anzen/databaseProviderOverview.json';
import userOverview from './anzen/users/userOverview.json';
import privilegeTable from './anzen/users/privilegeTable.json';
import activityChartsByUser from './anzen/users/activityChartsByUser.json';
import alertsTableList from './anzen/alertsTable.json';
import userConfigurationGraph from './anzen/users/userConfigurationGraph.json';
import tableConfigurationGraph from './anzen/tables/tableConfigurationGraph.json';
import checkIcon from './anzen/utils/checkIcon.json';
import alertCountByCategory from './anzen/alertCountByCategory.json';
import alertCountByScopeType from './anzen/alertCountByScopeType.json';
import alertCountBySeverity from './anzen/alertCountBySeverity.json';
import alertResolution from './anzen/alertResolution.json';
import cloudConnectionsCount from './anzen/cloudConnectionsCount.json';
import databaseConnectionsCount from './anzen/databaseProvidersCount.json';
import monitoredEntitiesPanel from './anzen/monitoredEntitiesPanel.json';
import clientActivity from './anzen/clients/clientActivity.json';
import clientOverview from './anzen/clients/clientOverview.json';
import alertGrid from './anzen/alerts/alertGrid.json';
import usersAndIPsTable from './anzen/clients/usersAndIPsTable.json';
import s3ObjectList from './anzen/s3/s3ObjectList.json';
import inactiveBucketHeading from './anzen/s3/inactiveBucketHeading.json';
import inactiveBucketOverview from './anzen/s3/inactiveBucketOverview.json';
import requestsAndBytesActivity from './anzen/s3/requestsAndBytesActivity.json';
import insecureAndRejectionActivity from './anzen/s3/insecureAndRejectionActivity.json';
import requesterAndIAMActivity from './anzen/s3/requesterAndIAMActivity.json';
import userDataExportActivity from './anzen/databaseExfiltrationES/userDataExportActivity.json';
import confidenceScorePanel from './anzen/databaseExfiltrationES/confidenceScorePanel.json';
import confidenceScoreIcon from './anzen/utils/confidenceScoreIcon.json';
import truncatedCell from './anzen/utils/truncatedCell.json';
import betaBanner from './anzen/utils/betaBanner.json';
import tagsTables from './anzen/tables/tagsTables.json';
import byPiiCategoryChart from './anzen/piiData/byPiiCategoryChart.json';
import byComplianceChart from './anzen/piiData/byComplianceChart.json';
import piiDataPieCharts from './anzen/piiData/piiDataPieCharts.json';
import byRegionChart from './anzen/piiData/byRegionChart.json';
import piiDataDiscoveryTable from './anzen/piiData/piiDataDiscoveryTable.json';

import tableExamples from './tableExamples';
import cartesianExamples from './cartesianExamples';

export default [
  // Documentation Examples
  ...tableExamples,
  ...cartesianExamples,

  // Anzen
  s3Heading,
  snowflakeHeading,
  dataExfiltrationMapES,
  eventTimelineES,
  exfiltrationDetailsPanelsES,
  dataExfiltrationMapLS,
  eventTimelineLS,
  exfiltrationDetailsPanelsLS,
  alertOverview,
  healthIcon,
  descriptionCell,
  tableOverview,
  columnsTable,
  usersTable,
  activityChartsByTable,
  anzenCellHealthIcon,
  overlayGraph,
  activityGraphColumn,
  activityGraphTable,
  configurationGraphColumn,
  tablePIIColumns,
  lineGraphColumns,
  databaseProviderOverview,
  userOverview,
  privilegeTable,
  activityChartsByUser,
  alertsTableList,
  userConfigurationGraph,
  tableConfigurationGraph,
  checkIcon,
  alertCountByCategory,
  alertCountByScopeType,
  alertCountBySeverity,
  alertResolution,
  cloudConnectionsCount,
  databaseConnectionsCount,
  monitoredEntitiesPanel,
  clientActivity,
  clientOverview,
  alertGrid,
  usersAndIPsTable,
  s3ObjectList,
  inactiveBucketHeading,
  inactiveBucketOverview,
  insecureAndRejectionActivity,
  requestsAndBytesActivity,
  requesterAndIAMActivity,
  userDataExportActivity,
  betaBanner,
  tagsTables,
  byPiiCategoryChart,
  byComplianceChart,
  piiDataPieCharts,
  byRegionChart,
  piiDataDiscoveryTable,

  // EC2
  confidenceScorePanel,
  confidenceScoreIcon,
  truncatedCell,
];
